<!-- <app-header></app-header> -->
<app-headertop5></app-headertop5>
<div class="wel-main">
  <div class="container-fuild banner">
    <div class="">
      <div class="col-md-12 text-center">
        <div class="container animate__animated animate__fadeInUp">
          <img src="https://cdn.virtueanalytics.com/cache/top5colleges.gif" />
          <h1>Top5 Colleges</h1>
          <p>
            A Multiple Scholarship Estimator tool provides high school students
            and their families with an easy, tabulated comparison of
            scholarships of all the chosen colleges.
          </p>
          <p>
            Your Top5 Colleges List determines your student's College Financial
            Success. <span>Choose Wisely! </span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row text-center mt-4 mb-3">
      <div class="col-md-12 head-sub animate__animated animate__fadeInDown">
        <h2>Features</h2>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-4 text-center feature-box mb-3 animate__animated animate__fadeInDown"
      >
        <img
          src="https://cdn.virtueanalytics.com/cache/colleges-university.gif"
        />
        <h3>1500+ Colleges & Universities</h3>
      </div>
      <div
        class="col-md-4 text-center feature-box mb-3 animate__animated animate__fadeInDown"
      >
        <img src="https://cdn.virtueanalytics.com/cache/top5-feature-2.gif" />
        <h3>40+ Courses Discipline</h3>
      </div>
      <div
        class="col-md-4 text-center feature-box mb-3 animate__animated animate__fadeInDown"
      >
        <img src="https://cdn.virtueanalytics.com/cache/top5-feature-3.gif" />
        <h3>Compare Award Letters</h3>
      </div>
      <div
        class="col-md-4 text-center feature-box mb-3 animate__animated animate__fadeInUp"
      >
        <img src="https://cdn.virtueanalytics.com/cache/top5-feature-4.gif" />
        <h3>Indepth Analytics with ML</h3>
      </div>
      <div
        class="col-md-4 text-center feature-box mb-3 animate__animated animate__fadeInUp"
      >
        <img src="https://cdn.virtueanalytics.com/cache/top5-feature-5.gif" />
        <h3>Compare out of pocket cost</h3>
      </div>
      <div
        class="col-md-4 text-center feature-box mb-4 animate__animated animate__fadeInUp"
      >
        <img src="https://cdn.virtueanalytics.com/cache/top5-feature-6.gif" />
        <h3>
          Compare Return on Investment<br />
          & NPV
        </h3>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
<app-virtuealert-modal #virtueAlertModal></app-virtuealert-modal>
